const ACRONYMS = new Set(["coi", "acord", "pdf", "api", "csv", "json"])

/** Converts a kebab-case skill name to a human-readable title. */
export const humanizeName = (name: string): string =>
  name
    .split("-")
    .map((word) => (ACRONYMS.has(word) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(" ")

export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replaceAll(/[^\w\s-]/g, "")
    .replaceAll(/[\s_-]+/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "")

export const DEFAULT_SKILLS: Record<string, { key: string; icon: string }> = {
  "generate-coi": { key: "generateCoi", icon: "file-contract" },
  "compare-policies": { key: "comparePolicies", icon: "scale-balanced" },
  "endorsement-review": { key: "endorsementReview", icon: "file-circle-check" },
  "loss-run-analysis": { key: "lossRunAnalysis", icon: "chart-line" },
  "policy-renewal-review": { key: "policyRenewalReview", icon: "arrows-rotate" },
  "review-claims": { key: "reviewClaims", icon: "clipboard-list" },
}

export const SKILL_ICONS: Record<string, string> = {
  "gail-call-analysis": "chart-line",
  "gail-call-results": "clipboard-list",
  "gail-call-transcripts": "file-lines",
  "gail-script-improvement": "file-pen",
  "gail-account-builder": "building",
}

export function skillIconName(name: string): string {
  return SKILL_ICONS[name] ?? DEFAULT_SKILLS[name]?.icon ?? "wand-magic-sparkles"
}
